import { useState, useEffect } from 'react';

export interface CookiePreferences {
  necessary: boolean;
  analytics: boolean;
  marketing: boolean;
  preferences: boolean;
}

export const useCookiePreferences = () => {
  const [preferences, setPreferences] = useState<CookiePreferences>({
    necessary: true,
    analytics: false,
    marketing: false,
    preferences: false
  });
  const [isAccepted, setIsAccepted] = useState(false);

  useEffect(() => {
    // Cargar preferencias guardadas
    const savedPreferences = localStorage.getItem('cookiePreferences');
    const accepted = localStorage.getItem('cookiesAccepted');
    
    if (savedPreferences) {
      setPreferences(JSON.parse(savedPreferences));
    }
    
    if (accepted) {
      setIsAccepted(true);
    }
  }, []);

  const savePreferences = (newPreferences: CookiePreferences) => {
    setPreferences(newPreferences);
    localStorage.setItem('cookiePreferences', JSON.stringify(newPreferences));
    localStorage.setItem('cookiesAccepted', 'true');
    setIsAccepted(true);
  };

  const acceptAll = () => {
    const allPreferences = {
      necessary: true,
      analytics: true,
      marketing: true,
      preferences: true
    };
    savePreferences(allPreferences);
  };

  const acceptNecessary = () => {
    const necessaryOnly = {
      necessary: true,
      analytics: false,
      marketing: false,
      preferences: false
    };
    savePreferences(necessaryOnly);
  };

  const resetPreferences = () => {
    localStorage.removeItem('cookiePreferences');
    localStorage.removeItem('cookiesAccepted');
    setPreferences({
      necessary: true,
      analytics: false,
      marketing: false,
      preferences: false
    });
    setIsAccepted(false);
  };

  return {
    preferences,
    isAccepted,
    savePreferences,
    acceptAll,
    acceptNecessary,
    resetPreferences
  };
}; 